export interface ProductDevelopmentProductFilters {
  colecao?: string
  familia?: string
  episodio?: string
}

export const EMPTY_PRODUCT_FILTERS: ProductDevelopmentProductFilters = {
  colecao: '',
  familia: '',
  episodio: '',
}

export function hasActiveProductFilters(
  filters: ProductDevelopmentProductFilters,
): boolean {
  return Boolean(
    filters.colecao?.trim() ||
      filters.familia?.trim() ||
      filters.episodio?.trim(),
  )
}
